/**
 * Registrar Api
 * The registrar api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Condition } from './condition';


export interface DisplayModel { 
    value: DisplayModel.ValueEnum;
    initialValue: DisplayModel.InitialValueEnum;
    conditions: Array<Condition>;
}
export namespace DisplayModel {
    export type ValueEnum = 'hidden' | 'visible' | 'toggle';
    export const ValueEnum = {
        Hidden: 'hidden' as ValueEnum,
        Visible: 'visible' as ValueEnum,
        Toggle: 'toggle' as ValueEnum
    };
    export type InitialValueEnum = 'hidden' | 'visible' | 'toggle';
    export const InitialValueEnum = {
        Hidden: 'hidden' as InitialValueEnum,
        Visible: 'visible' as InitialValueEnum,
        Toggle: 'toggle' as InitialValueEnum
    };
}


